import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { DollarSign, ChevronRight, Loader2, TrendingUp, Sparkles } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * MoneyMakerTile — daily AI-vetted money-making opportunity card.
 * Mounted on the Home page; opens the full /columns/money_maker page on click.
 */
export default function MoneyMakerTile() {
  const [col, setCol] = useState(null);
  const [busy, setBusy] = useState(true);

  useEffect(() => {
    let cancelled = false;
    axios.get(`${API}/columns/money-maker/today`, { timeout: 90000 })
      .then((r) => { if (!cancelled) setCol(r.data?.column); })
      .catch(() => {})
      .finally(() => { if (!cancelled) setBusy(false); });
    return () => { cancelled = true; };
  }, []);

  return (
    <section className="rounded-2xl border-2 border-[var(--gold)] bg-gradient-to-br from-[#fff7d6] via-[#fde68a] to-[#f59e0b] p-5 my-6" data-testid="money-maker-tile">
      <div className="flex items-start gap-4 flex-wrap">
        <div className="w-14 h-14 rounded-xl bg-[#1d1303] flex items-center justify-center shrink-0">
          <DollarSign size={28} className="text-[var(--gold)]" />
        </div>
        <div className="flex-1 min-w-[240px]">
          <div className="text-[10px] uppercase tracking-[0.22em] font-black text-[#1d1303] mb-1">
            <Sparkles size={11} className="inline mr-1" /> Money-Maker of the day · Newseze Money Desk
          </div>
          {busy && (
            <div className="flex items-center gap-2 text-[#1d1303] text-[13px]">
              <Loader2 size={14} className="animate-spin" /> Today's vetted opportunity is loading…
            </div>
          )}
          {!busy && col && (
            <>
              <h3 className="text-[20px] sm:text-[24px] font-black tracking-[-0.02em] text-[#1d1303] leading-tight" data-testid="money-maker-headline">
                {col.headline}
              </h3>
              {col.deck && <p className="text-[13.5px] text-[#1d1303]/85 mt-1 leading-snug" data-testid="money-maker-deck">{col.deck}</p>}
              <div className="flex items-center gap-2 flex-wrap mt-3">
                {typeof col.score === "number" && (
                  <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-[#1d1303] text-[var(--gold)] text-[11px] uppercase tracking-[0.16em] font-black" data-testid="money-maker-score">
                    <TrendingUp size={11} /> Truthfulness · {col.score}/100
                  </span>
                )}
                <Link to="/columns/money_maker" className="inline-flex items-center gap-1 px-3 py-1.5 rounded-md bg-[#1d1303] text-[var(--gold)] text-[12px] font-black hover:opacity-90" data-testid="money-maker-cta">
                  Read the full vetting <ChevronRight size={12} />
                </Link>
              </div>
            </>
          )}
          {!busy && !col && (
            <p className="text-[13px] text-[#1d1303]/85" data-testid="money-maker-empty">
              Today's opportunity hasn't been published yet — check back at 6:30 a.m. local.
            </p>
          )}
        </div>
      </div>
    </section>
  );
}
